import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { applyUkgUserTimeZoneTransformation } from '@commonClient2/services/ukgDateTime';

const useCountdown = (sourceEndTime) => {
    const { t } = useTranslation('shiftBidding');

    const userTime = applyUkgUserTimeZoneTransformation(new Date()).getTime() / 1000;
    const endTime = sourceEndTime ? sourceEndTime.getTime() / 1000 : userTime;
    const initialTimeLeft = endTime - userTime;
    /** @type {React.MutableRefObject<NodeJS.Timer | undefined>} */
    const intervalRef = useRef();
    const [timeLeft, setTimeLeft] = useState(initialTimeLeft);
    const decreaseTime = () => setTimeLeft((prev) => prev - 1);

    const d = Math.floor(timeLeft / (3600 * 24));
    const h = Math.floor((timeLeft % (3600 * 24)) / 3600);
    const m = Math.floor((timeLeft % 3600) / 60);
    const s = Math.floor((timeLeft % 60));
    
    const daysLeft = d > 0 ? d + (d === 1 ? ` ${t('common.day')}, ` : ` ${t('common.days')}, `) : '';
    const hoursLeft = h > 0 ? h + (h === 1 ? ` ${t('common.hour')}, ` : ` ${t('common.hours')}, `) : '';
    const minutesLeft = m > 0 ? m + (m === 1 ? ` ${t('common.minute')} ` : ` ${t('common.minutes')} `) : '';
    const secondsLeft = m <= 0 && s > 0 ? s + (s === 1 ? ` ${t('common.second')} ` : ` ${t('common.seconds')} `) : '';
    const timeLeftText = daysLeft + hoursLeft + minutesLeft + secondsLeft;

    useEffect(() => {
        intervalRef.current = setInterval(decreaseTime, 1000);
        // @ts-ignore
        return () => clearInterval(intervalRef.current);
    }, []);

    return timeLeftText;
};

export default useCountdown;
